import {useCallback, useState} from "react";
import {useDispatch} from "react-redux";
import {rxToggleLeftMenu} from "./slices/appSlice";
import {initializeApp} from "firebase/app";
import {getAuth, onAuthStateChanged, signOut} from "firebase/auth";
import {useNavigate} from "react-router";

const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_MESSAGING_APP_ID
};

initializeApp(FIREBASE_CONFIG);

let signingOut = false;

const useApp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [initialized, setInitialized] = useState(false);

  const auth = getAuth();

  onAuthStateChanged(auth, (user) => {
    if (user && !initialized) {
      const splash = document.getElementById("splash");

      if (splash) {
        splash.remove();
      }

      setInitialized(true);
    } else if (!user && !signingOut) {
      navigate("/signin");
    }
  });

  const toggleLeftMenu = useCallback(() => dispatch(rxToggleLeftMenu()), [dispatch]);

  const closeLeftMenuMobile = useCallback(() => {
    if (window.innerWidth < 1500) {
      toggleLeftMenu();
    }
  }, [toggleLeftMenu]);

  const logout = () => {
    signingOut = true;

    return signOut(getAuth()).then(() => {
      window.location.href = "/";
    });
  };

  return {
    toggleLeftMenu,
    closeLeftMenuMobile,
    logout,
    initialized
  };
};

export default useApp;
